import React from 'react';

const UKFlagIcon = ({ className, ...props }) => (
  <span className={`fi fi-gb ${className || ''}`} {...props} />
);

const SerbiaFlagIcon = ({ className, ...props }) => (
  <span className={`fi fi-rs ${className || ''}`} {...props} />
);

export { UKFlagIcon, SerbiaFlagIcon };
